import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"close\"><path fill-rule=\"evenodd\" d=\"m5.1 1.596 9.9 9.899 9.9-9.899a2.5 2.5 0 0 1 3.404-.122l.131.122a2.5 2.5 0 0 1 0 3.536l-9.9 9.899 9.9 9.9a2.5 2.5 0 1 1-3.536 3.535l-9.9-9.9-9.898 9.9a2.5 2.5 0 0 1-3.405.122l-.131-.122a2.5 2.5 0 0 1 0-3.535l9.899-9.9-9.899-9.9a2.5 2.5 0 1 1 3.536-3.535z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol